import React from "react";
import { occurrenceCountLabel } from "../../domain/inconsistencies";

function SprintGroupHeader({ id, title, count }) {
  return (
    <div className="group-head">
      <h3 className="group-title" id={id}>
        {title}
      </h3>
      <span className="group-count">{occurrenceCountLabel(count)}</span>
    </div>
  );
}

export default SprintGroupHeader;
